import { render, staticRenderFns } from "./WechatPayDialog.vue?vue&type=template&id=f5edbf12&"
import script from "./WechatPayDialog.vue?vue&type=script&lang=js&"
export * from "./WechatPayDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports